import { db } from '../../src/firebase.js';
import { doc, getDoc } from 'firebase/firestore';
import { sidebarPage } from '../utils/sidebarPageLayout.js';
import { renderTiagoMarkdown } from '../tiago/tiagoMarkdown.js';

export class TiagoShare {
  constructor(containerId, token) {
    this.containerId = containerId;
    this.token = token;
  }

  async init() {
    const el = document.getElementById(this.containerId);
    if (!el || !this.token) {
      el.innerHTML = '<p>Invalid share link.</p>';
      return;
    }
    const snap = await getDoc(doc(db, 'tiagoSharedChats', this.token));
    if (!snap.exists()) {
      el.innerHTML = sidebarPage({
        title: 'Tiago',
        main: '<div class="tiago-share-page"><p>This shared chat has expired or does not exist.</p></div>',
        wide: true,
      });
      return;
    }
    const data = snap.data();
    const rows = (data.messages || []).map((m) => `
      <div class="message-row ${m.sender}">
        ${m.sender === 'assistant' ? '<img src="/images/tiago.png" class="msg-avatar" alt="">' : ''}
        <div class="msg-bubble">${m.sender === 'assistant' ? renderTiagoMarkdown(m.text) : m.text}</div>
      </div>
    `).join('');

    el.innerHTML = sidebarPage({
      title: data.title || 'Shared chat',
      main: `
        <div class="tiago-share-page">
          <p class="tiago-share-note">Read-only shared conversation from FootballGirl Tiago AI</p>
          <div class="chat-window tiago-share-messages">${rows}</div>
        </div>
      `,
      wide: true,
      pageClass: 'tiago-page',
    });
  }
}
